import { Link, useLocation } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items?: BreadcrumbItem[];
}

const routeLabels: Record<string, string> = {
  '': '首页',
  'category': '分类',
  'comic': '漫画详情',
  'about': '关于我们',
};

const categoryNames: Record<string, string> = {
  'all': '全部漫画',
  'romance': '恋爱言情',
  'fantasy': '奇幻冒险',
  'action': '热血动作',
  'comedy': '搞笑日常',
  'drama': '剧情悬疑',
  'thriller': '惊悚恐怖',
  'school': '校园青春',
  'historical': '古风历史',
  'bl': 'BL耽美',
};

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const location = useLocation();

  const generateBreadcrumbs = (): BreadcrumbItem[] => {
    if (items) return items;

    const paths = location.pathname.split('/').filter(Boolean);
    const breadcrumbs: BreadcrumbItem[] = [{ label: '首页', href: '/' }];

    if (paths.length === 0) return breadcrumbs;

    if (paths[0] === 'category') {
      breadcrumbs.push({ label: '漫画分类', href: '/category/all' });
      if (paths[1] && categoryNames[paths[1]]) {
        breadcrumbs.push({ label: categoryNames[paths[1]] });
      }
    } else if (paths[0] === 'comic') {
      breadcrumbs.push({ label: '漫画详情' });
    } else if (paths[0] === 'about') {
      breadcrumbs.push({ label: '关于我们' });
    } else {
      const label = routeLabels[paths[0]] || paths[0];
      breadcrumbs.push({ label, href: `/${paths[0]}` });
    }

    return breadcrumbs;
  };

  const breadcrumbs = generateBreadcrumbs();

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumbs.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.label,
      item: item.href ? `https://mousehole.cn${item.href}` : undefined,
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <nav aria-label="面包屑导航" className="flex items-center gap-1.5 text-sm text-foreground-600 py-4 px-4 md:px-6 max-w-7xl mx-auto w-full">
        {breadcrumbs.map((item, index) => (
          <span key={index} className="flex items-center gap-1.5">
            {index > 0 && (
              <i className="ri-arrow-right-s-line text-foreground-400 text-xs"></i>
            )}
            {item.href ? (
              <Link to={item.href} className="hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-950 font-medium whitespace-nowrap">{item.label}</span>
            )}
          </span>
        ))}
      </nav>
    </>
  );
}